import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {ButtonLabelPaddingDefaultBox} from "./button-label-padding.default.box";
import {ButtonLabelPaddingCasino888Box} from "./button-label-padding.casino888.box";
import {ButtonLabelPaddingCasino777Box} from "./button-label-padding.casino777.box";
import {ButtonLabelPaddingSIBox} from "./button-label-padding.si.box";


export const ButtonLabelPaddingBox = styledByTheme(ButtonLabelPaddingDefaultBox)
    .forCasino888(ButtonLabelPaddingCasino888Box)
    .forCasino777(ButtonLabelPaddingCasino777Box)
    .forSI(ButtonLabelPaddingSIBox)
    .apply();
